import axios from 'axios'
import history from '../history'

import SetRoleUser from '../role/SetRoleUser'
import { encrypt } from '../util/CryptoUtil'

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})
const HEADERS = {
    'Content-Type': 'application/json'
};

export async function getPerfilUsuario(dispatch) {
    const AuthToken = 'Bearer '.concat(localStorage.getItem(process.env.REACT_APP_TOKENUSER));

    dispatch({ type: 'OPEN_LOADING' })
    await http.get('/account/getperfil',
        {
            headers: {
                HEADERS,
                'Authorization': AuthToken
            }
        }).then(response => {
            successGetPerfilUsuario(response, dispatch);
        }).catch(erro => {
            console.log(erro)
            erroGetPerfilUsuario(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successGetPerfilUsuario(response, dispatch) {
    if (response.status === 200) {

        const userEncrypted = encrypt(JSON.stringify(response.data));
        localStorage.setItem(process.env.REACT_APP_USER, userEncrypted);

        if (response.data.isCompleted === "False") {
            const role = 'completeUser'
            SetRoleUser(dispatch, role);
            history.push('/completar-cadastro')

            dispatch({
                type: 'OPEN_ALERT_DIALOG',
                title: 'Completar Cadastro',
                description: 'É necessário completar o cadastro para utilizar a ferramenta.'
            })
        } else {
            const role = response.data.roles[0];
            SetRoleUser(dispatch, role);
            dispatch({
                type: 'SET_USER',
                user: response.data,
            })
            history.push('/inicial')
        }
    }
}

function erroGetPerfilUsuario(erro, dispatch) {
    if (erro.status === 401) {
        history.push('/login')
    }
}